"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmobilityChargeStationDetails = void 0;
const tslib_1 = require("tslib");
const apigw_models_1 = require("@integration/apigw-models");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const ChargingStationType_1 = require("./enums/ChargingStationType");
const ChargingStationColor_1 = require("./enums/ChargingStationColor");
const mount_type_1 = tslib_1.__importDefault(require("./enums/mount-type"));
class EmobilityChargeStationDetails extends apigw_models_1.Serializable {
}
exports.EmobilityChargeStationDetails = EmobilityChargeStationDetails;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(ChargingStationType_1.ChargingStationType),
    (0, apigw_models_1.Docs)({
        example: ChargingStationType_1.ChargingStationType.ProLine,
        description: `The type of the charge station`,
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], EmobilityChargeStationDetails.prototype, "type", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(ChargingStationColor_1.ChargingStationColor),
    (0, apigw_models_1.Docs)({
        example: ChargingStationColor_1.ChargingStationColor.White,
        description: `Charging station color`,
    }),
    tslib_1.__metadata("design:type", String)
], EmobilityChargeStationDetails.prototype, "color", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, apigw_models_1.Docs)({
        example: false,
        description: `Whether the charging station has a fixed cable`,
    }),
    tslib_1.__metadata("design:type", Boolean)
], EmobilityChargeStationDetails.prototype, "fixedCable", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(mount_type_1.default),
    (0, apigw_models_1.Docs)({
        example: mount_type_1.default.Pole,
        description: `Charging station mount type`,
    }),
    tslib_1.__metadata("design:type", String)
], EmobilityChargeStationDetails.prototype, "mountType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, apigw_models_1.Docs)({ example: false, description: `Whether the customer is interested in reimbursement` }),
    tslib_1.__metadata("design:type", Boolean)
], EmobilityChargeStationDetails.prototype, "interestedInReimbursement", void 0);
